import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidFootballBallIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m5.6 16.9 3.5-3.5-.7-.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l.7.7 1.4-1.4-.7-.7c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l.7.7L17.5 5l2.3-2.3c-.5-.3-1-.5-1.6-.5-4.5-.5-8.9 1-12.1 4.2C2.9 9.6 1.4 14 1.9 18.5c.1.6.3 1.1.5 1.6l3.2-3.2ZM21.9 5.6c-.1-.6-.3-1.1-.6-1.6L19 6.3l-4.2 4.2.7.7c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3l-.7-.6-1.4 1.4.7.7c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3-.3 0-.5-.1-.7-.3l-.7-.7-3.5 3.5-3 3c.5.3 1 .5 1.6.5.5.2 1.1.2 1.7.2 3.9 0 7.6-1.5 10.3-4.3 3.2-3.2 4.7-7.6 4.2-12.1Z"/>
  </SvgIcon>
}

export default SolidFootballBallIcon
